import type * as Sentry from '@sentry/react';

type SentryEnvs = 'production' | 'debug';

export const sentryEnvironment: SentryEnvs = location.hostname.includes('f.weavedev.net') ? 'debug' : 'production';

/**
 * NOTE: This sample rate is applied in beforeSend. Do NOT also set `sampleRate` in the
 * Sentry.init config, or errors will be double-sampled.
 */
export const DEFAULT_SAMPLE_RATE = sentryEnvironment === 'production' ? 0.25 : 0;

/**
 * This function is used as the beforeSend callback in Sentry.init. It applies a sample rate to events in production, with an optional override at the event level.
 * If the function returns null, the event is dropped and not sent to Sentry.
 * If it returns the event, the event is sent to Sentry.
 */
export function beforeSend(event: Sentry.ErrorEvent, _hint: Sentry.EventHint) {
  // the event can override the default sample rate in production, otherwise it falls back to the default
  const eventSampleRate =
    sentryEnvironment === 'production' && typeof event?.contexts?.meta?.sampleRate === 'number'
      ? event.contexts.meta.sampleRate
      : undefined;
  const sampleRate = eventSampleRate ?? DEFAULT_SAMPLE_RATE;
  return Math.random() < sampleRate ? event : null;
}
